import register from '../../../../global/js/registry';
export default register('m-teaser-product', () => import(/* webpackMode: "lazy" */ './m-teaser-product.controller'));
